import React from 'react';
import { useTranslation } from 'react-i18next';
import { getMenuDiscountMeta } from '../../utils/menu.utils';
import { IDiscountBadgeProps } from '../../lib/types';


export const DiscountBadge: React.FC<IDiscountBadgeProps> = ({ menuItem }) => {
  const { t } = useTranslation();
  const { discountCurrency, discountValue, isPercentage, hasDiscount } = getMenuDiscountMeta(menuItem);

  if (!hasDiscount || !discountValue) {
    return null;
  }

  return (
    <span className="wdp-ribbon wdp-ribbon-two">
      <span className="d-flex align-items-end">
        {isPercentage ? (
          <>
            <h5 className="mb-0 pkr-title">{discountValue}</h5>
            <h5 className="rs-title mb-0"> {t("OFF")}</h5>
          </>
        ) : (
          <>
            <h5 className="rs-title mb-0">{discountCurrency}</h5>
            <h5 className="mb-0 pkr-title">{discountValue}</h5>
            <h5 className="rs-title mb-0"> {t("OFF")}</h5>
          </>
        )}
      </span>
    </span>
  );
};
